import { observer } from 'mobx-react'
import React, { Component } from "react"

@observer
export default class TopMenu extends Component {
    render() {
        const { changeZoom, lockCurrentMap, canSave, saveMap, startCloning, resetBoardView, position } = this.props
        return (
            <div className={"topMenu right"} style={{ textAlign: "right" }}>
                <button
                    style={!canSave ? { opacity: 0.35 } : {}}
                    onClick={canSave ? saveMap : () => alert("Cannot save a locked map. Clone first")} >
                    <i className="fa fa-floppy-o"></i>
                    &nbsp; Save
                </button>
                <button onClick={startCloning}>
                    <i className="fa fa-clone"></i>
                    &nbsp; Clone
                </button>
                <br/>
                <button 
                    style={!canSave ? { opacity: 0.35 } : {}}
                    onClick={lockCurrentMap} >
                    <i className="fa fa-lock"></i>
                </button>
                <button onClick={resetBoardView} >
                    <i className="fa fa-arrows-alt"></i>
                </button>
                <br/>
                <button 
                    onClick={()=> changeZoom(-1)} >
                    <i className="fa fa-search-plus"></i>
                </button>
                <br/>
                <button 
                    onClick={()=> changeZoom(1)} >
                    <i className="fa fa-search-minus"></i>
                </button>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/components/TopMenu.js